const lang = {
    'title': 'GoShare - Gogoro 移動共享服務 | 城市探險，說走就走！',
    'description': '一鍵啟動，在城市兜兜風！GoShare 與你一同探索城市移動的無限可能！24 小時隨訂隨還 Gogoro 智慧電動機車超方便 !',
};

export default lang;
